import { render, staticRenderFns } from "./IdmsAuth.vue?vue&type=template&id=8ea8337a&scoped=true"
import script from "./IdmsAuth.vue?vue&type=script&lang=js"
export * from "./IdmsAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea8337a",
  null
  
)

export default component.exports